import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ToasterService } from "@shared/services/toaster.service";
import {
    AdminWebhooksBridgeManageSelfhostedComponent,
    ManageSelfhostedWebhooksBridgeDialogContext
} from "./manage-selfhosted/manage-selfhosted.component";
import { FE_WebhooksBridge } from "@shared/models/webhooks";
import { AdminWebhooksApiService } from "@shared/services/admin/admin-webhooks-api.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SpinnerComponent } from "../../../elements/spinner/spinner.component";
import { IboxComponent } from "../../../elements/ibox/ibox.component";
import { LogService } from "@shared/services/log.service";


@Component({
    templateUrl: "./webhooks.component.html",
    styleUrls: ["./webhooks.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, IboxComponent, TranslatePipe]
})
export class AdminWebhooksBridgeComponent implements OnInit {

    public isLoading = true;
    public isUpdating = false;
    public configurations: FE_WebhooksBridge[] = [];

    constructor(
        private readonly webhooksApi: AdminWebhooksApiService,
        private readonly toaster: ToasterService,
        private readonly modal: NgbModal,
        public translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
    }

    public ngOnInit() {
        this.reload().then(() => this.isLoading = false);
    }

    private async reload(): Promise<any> {
        try {
            this.configurations = await this.webhooksApi.getBridges();
        } catch (err) {
            this.logService.error(err);
            this.translate.get('Error loading bridges').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        }
    }

    public addSelfHostedBridge() {
        const selfhostedRef = this.modal.open(AdminWebhooksBridgeManageSelfhostedComponent, {
            backdrop: 'static',
            size: 'lg',
        });
        selfhostedRef.result.then(async () => {
            try {
                await this.reload();
            } catch (err) {
                this.logService.error(err);
                this.translate.get('Failed to get an update Webhooks bridge list').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            }
        });
        const selfhostedInstance = selfhostedRef.componentInstance as ManageSelfhostedWebhooksBridgeDialogContext;
        selfhostedInstance.provisionUrl = '';
        selfhostedInstance.sharedSecret = '';
        selfhostedInstance.allowMxPuppets = false;
        selfhostedInstance.allowTgPuppets = false;
    }

    public editBridge(bridge: FE_WebhooksBridge) {
        const selfhostedRef = this.modal.open(AdminWebhooksBridgeManageSelfhostedComponent, {
            backdrop: 'static',
            size: 'lg',
        });
        selfhostedRef.result.then(async () => {
            try {
                await this.reload();
            } catch (err) {
                this.logService.error(err);
                this.translate.get('Failed to get an update Webhooks bridge list').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            }
        });
        const selfhostedInstance = selfhostedRef.componentInstance as ManageSelfhostedWebhooksBridgeDialogContext;
        selfhostedInstance.provisionUrl = bridge.provisionUrl;
        selfhostedInstance.sharedSecret = bridge.sharedSecret
        selfhostedInstance.bridgeId = bridge.id;
        selfhostedInstance.isAdding = !bridge.id;
    }
}
